import PropTypes from 'prop-types';
import React from 'react';

import { Link } from '@ontruck/orc';

import Text from './Text';

const GoogleMapsLink = ({
  text,
  skin = 'secondary',
  showDistance = true,
  item = {},
  handleClick,
  showIcon = true,
}) => {
  return (
    <Link
      {...((showIcon && { iconPosition: 'left', icon: 'google-maps' }) || {})}
      skin={skin}
      weight="bold"
      text={<Text text={text} showDistance={showDistance} item={item} />}
      onClick={handleClick}
    />
  );
};

GoogleMapsLink.propTypes = {
  skin: PropTypes.string,
  showDistance: PropTypes.bool,
  item: PropTypes.object,
  handleClick: PropTypes.func,
  text: PropTypes.string,
  showIcon: PropTypes.bool,
};

export default GoogleMapsLink;
